import styled from 'styled-components'
import { Grid } from 'components/grid'

export const Fields = styled.div`
    form:last-child & > :last-child {
        margin-block-end: 0;
    }
`

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;

    &:not(.compact) {
        margin-block-end: 24px;
    }
`

export const EmptyColumns = styled(Grid)`
    grid-auto-flow: column;
    grid-auto-columns: auto;
    justify-content: start;
    column-gap: 8px;
`